<div class="row">
    <div class="col-md-12 date-picker-score-accumulator-wrapper">
        <app-review-date-picker [datePickerMode]="DatePickerModeEnum.Date"
                                (dateSelected)="onDateSelected($event)"></app-review-date-picker>
        <app-average-score-accumulators
                (averageScoreAccumulatorSelected)="onAverageScoreAccumulatorSelected($event)"></app-average-score-accumulators>
    </div>
</div>
<app-sites-table></app-sites-table>


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/sites/sites.component.html